"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _ui = require("@alycecom/ui");

var useStyles = (0, _styles.makeStyles)({
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none'
  }
});

var GiftPreview = function GiftPreview(_ref) {
  var landingAvailable = _ref.landingAvailable,
      emailAvailable = _ref.emailAvailable,
      onEmailPreview = _ref.onEmailPreview,
      onLandingPreview = _ref.onLandingPreview,
      emailDisabled = _ref.emailDisabled,
      landingDisabled = _ref.landingDisabled,
      boxProps = (0, _objectWithoutProperties2.default)(_ref, ["landingAvailable", "emailAvailable", "onEmailPreview", "onLandingPreview", "emailDisabled", "landingDisabled"]);
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Box, (0, _extends2.default)({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, boxProps), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, "Want to see a preview?"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row"
  }, emailAvailable && /*#__PURE__*/_react.default.createElement(_material.Button, {
    onClick: onEmailPreview,
    className: (0, _classnames.default)({
      [classes.disabled]: emailDisabled
    }, 'Button-Link')
  }, "View message"), emailAvailable && landingAvailable && /*#__PURE__*/_react.default.createElement(_ui.AlyceDivider, {
    orientation: "vertical"
  }), landingAvailable && /*#__PURE__*/_react.default.createElement(_material.Button, {
    onClick: onLandingPreview,
    className: (0, _classnames.default)({
      [classes.disabled]: landingDisabled
    }, 'Button-Link')
  }, "View landing page")));
};

GiftPreview.propTypes = {
  landingAvailable: _propTypes.default.bool,
  emailAvailable: _propTypes.default.bool,
  emailDisabled: _propTypes.default.bool,
  landingDisabled: _propTypes.default.bool,
  onEmailPreview: _propTypes.default.func,
  onLandingPreview: _propTypes.default.func
};
GiftPreview.defaultProps = {
  landingAvailable: false,
  emailAvailable: false,
  onEmailPreview: function onEmailPreview() {},
  onLandingPreview: function onLandingPreview() {},
  emailDisabled: false,
  landingDisabled: false
};

var _default = /*#__PURE__*/(0, _react.memo)(GiftPreview);

exports.default = _default;